<script lang="ts">
  import { run } from "svelte/legacy";
  import { emptyMeltElement, melt } from "@melt-ui/svelte";
  import type { Snippet } from "svelte";
  import type { HTMLInputAttributes } from "svelte/elements";
  import type { Except } from "type-fest";

  interface Props extends Except<HTMLInputAttributes, "size" | "prefix"> {
    type?: string;
    size?: "sm" | "md";
    value?: string;
    trimmedValue?: string | undefined;
    meltElement?: any;
    wrapperMeltElement?: any;
    prefix?: Snippet;
    suffix?: Snippet;
    inputClass?: string;
  }

  let {
    type = "input",
    disabled = false,
    size = "md",
    value = $bindable(""),
    trimmedValue = $bindable(),
    meltElement = emptyMeltElement,
    wrapperMeltElement = emptyMeltElement,
    prefix,
    suffix,
    class: className,
    inputClass,
    ...rest
  }: Props = $props();

  run(() => {
    trimmedValue = typeof value === "string" ? value.trim() : value;
  });
</script>

<div
  {...$wrapperMeltElement} use:$wrapperMeltElement.action
  class:disabled
  class={[
    "wrapper flex shrink-0 items-center rounded-lg bg-mono-000 shadow-border-inset select-none",
    size,
    "gap-2 px-3",
    prefix ? "pl-2.5" : "",
    suffix ? "pr-2.5" : "",
    "outline-2 outline-transparent transition-colors duration-150 focus-within:outline focus-within:outline-offset-2 focus-within:outline-focus-subtle",
    className,
  ]}
>
  {#if prefix}
    <span class="flex items-center text-subtle">
      {@render prefix?.()}
    </span>
  {/if}
  <input
    bind:value
    {...$meltElement} use:$meltElement.action
    {...rest}
    {disabled}
    {...{ type }}
    class={[
      "input h-full flex-1 truncate rounded-[inherit] bg-transparent text-sm placeholder:text-placeholder focus:outline-hidden",
      inputClass,
    ]}
  />
  {#if suffix}
    <span class="flex items-center text-subtle">
      {@render suffix?.()}
    </span>
  {/if}
</div>

<style>
  @reference "#tailwind.css";
  .wrapper {
    &.sm {
      height: var(--spacing-input-height-sm);
    }

    &.md {
      height: var(--spacing-input-height-md);
    }

    &.disabled {
      background: var(--color-mono-200);
      cursor: not-allowed;

      input {
        cursor: not-allowed;
      }
    }
  }
</style>
